module.exports = __webpack_public_path__ + "img/logo.edc7d222.png";